/* src/app/timeline-transport/pages/timeline-transport/timeline-transport.component.scss */
.timelineLineContainer {
  display: flex;
  flex-flow: row wrap;
}
.fullcontainer {
  padding-left: 18rem;
}
.articContainer {
  padding-left: 33rem;
}
.hide {
  display: none;
}
/*# sourceMappingURL=timeline-transport.component.css.map */
